import React from 'react';
import loadable from '@loadable/component';

import { Helpers } from '../core/src/helpers';
import { dynamicLoadData } from '../page';

const CartPageContainer = loadable(() => Helpers.retryFunc(() => import('./cart-page-container')));

/**
 * Default SSR load function with graphql endpoint
 * @name loadGraphQLData
 * @param {*} urlParams
 * @param {*} store
 * @param {*} querySelector
 * @returns
 */
export const loadGraphQLData = async (urlParams, store, context = {}) => {
    const { dir } = urlParams;
    await dynamicLoadData(dir, store, context);
    const { slugInfo, redirects, basename } = store.getState();

    const needRedirect = !slugInfo || slugInfo.error || (redirects && redirects.count !== 0);

    const { destination = `${basename}/slp/weekly-deals`, status = 301 } = redirects;
    if (needRedirect) return Promise.resolve({ status, destination });

    return Promise.resolve(slugInfo);
};

export default {
    component: CartPageContainer,
    loadData: loadGraphQLData,
};
